export default {
  saveDedicatedDomain(state, payload) {
    state.dedicatedDomain = payload;
  },
  saveDedicatedDomainCount(state, payload) {
    state.dedicatedDomainCount = payload;
  },
};